<template>
  <el-date-picker
  style='width:100%;'
    v-model="dateValue"
    type="daterange"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    @change="timeChange"
    value-format="yyyy-MM-dd"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: 'datepicker',
  props: {
    startTime: {
      required: true
    },
    endTime: {
      required: true
    }
  },
  watch: {
    times(val) {
      if (!val.startTime && !val.endTime) {
        this.dateValue = ''
      }
    }
  },
  data() {
    return {
      dateValue: ''
    }
  },
  methods: {
    timeChange(e) {
      this.$emit('update:startTime', e[0])
      this.$emit('update:endTime', e[1])
    }
  },
  computed: {
    times() {
      const { startTime, endTime } = this
      return {
        startTime,
        endTime
      }
    }
  }
}
</script>

<style></style>
